import { lazy, Suspense } from 'react';

import { Loading } from '../../components/ui.jsx';

/** Domains in the web app: public search, the client's domains, and staff pages. */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const search = () => import('./DomainSearch.jsx');
const client = () => import('./ClientDomains.jsx');
const admin = () => import('./AdminDomains.jsx');
const setup = () => import('./AdminDomainSetup.jsx');
const priceSync = () => import('./AdminPriceSync.jsx');

const ClientDomainsTabLazy = lazy(() => admin().then((m) => ({ default: m.ClientDomainsTab })));
function ClientDomainsTab(props) {
  return (
    <Suspense fallback={<Loading />}>
      <ClientDomainsTabLazy {...props} />
    </Suspense>
  );
}

export default {
  name: 'domains',
  publicRoutes: [{ path: 'domains/search', lazy: page(search, 'DomainSearch') }],
  clientRoutes: [
    { path: 'domains', lazy: page(client, 'ClientDomains') },
    { path: 'domains/:uuid', lazy: page(client, 'ClientDomainDetail') },
  ],
  adminRoutes: [
    { path: 'domains', lazy: page(admin, 'AdminDomains') },
    { path: 'domains/pricing', lazy: page(setup, 'DomainPricing') },
    { path: 'domains/price-sync', lazy: page(priceSync, 'DomainPriceSync') },
    { path: 'domains/registrars', lazy: page(setup, 'DomainRegistrars') },
    { path: 'domains/tasks', lazy: page(setup, 'DomainTasks') },
    { path: 'domains/:uuid', lazy: page(admin, 'AdminDomainDetail') },
  ],
  clientNav: [{ key: 'domains', to: '/domains', label: 'Domains', order: 30, auth: true }],
  adminNav: [
    { section: 'domains', to: '/admin/domains', label: 'Domains', permission: 'admin.domains.read', order: 10 },
    {
      section: 'domains',
      to: '/admin/domains/pricing',
      label: 'TLD pricing',
      permission: 'admin.domains.read',
      order: 20,
    },
    {
      section: 'domains',
      to: '/admin/domains/price-sync',
      label: 'Price sync',
      permission: 'admin.domains.read',
      order: 25,
    },
    {
      section: 'domains',
      to: '/admin/domains/registrars',
      label: 'Registrars',
      permission: 'admin.domains.registrar',
      order: 30,
    },
    { section: 'domains', to: '/admin/domains/tasks', label: 'Tasks', permission: 'admin.domains.read', order: 40 },
  ],
  adminClientTabs: [
    { key: 'domains', label: 'Domains', order: 20, permission: 'admin.domains.read', Component: ClientDomainsTab },
  ],
};
